import React, { Fragment } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import '../../../../styles/diario.scss'


const Terc = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.terc.nome} / {props.terc.cargo}</Card.Title>
                        <p>Empresa: {props.terc.empresa}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Terc;